const animation = require("./mooLeft.json");

module.exports = {
    loop: false,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid'
    },
}